import { Directive, ElementRef, HostListener } from '@angular/core';

// https://www.youtube.com/watch?v=ENRqBlm3fLU

@Directive({
    'selector': '[appPhoneMask]',
    'standalone': true
})
export class PhoneMaskDirective {
    constructor(private elementRef: ElementRef) {
    }

    @HostListener('input', ['$event'])
    public onInputChange(e: any) {
        const value = e.target.value;
        const caretPos = e.target.selectionStart;
        const formattedPhoneNumber = this.formatPhoneNumber(value);
        this.elementRef.nativeElement.value = formattedPhoneNumber;
        if (caretPos < value.length) {
            e.target.setSelectionRange(caretPos, caretPos);
        }
        // e.target.selectionStart = caretPos;
        // e.target.selectionEnd = caretPos;

        // let keyCode = e.keyCode;
        // let key = e.key;
    }

    // Format phonenumber as: (xxx) xxx-xxxx
    // or as close as possible if phonenumber length is not 10
    //
    // Returns formatted number:
    // If number.length === 10 : (###) ###-####
    // If number.length < 4    : ###
    // If number.length < 7    : (###) ###
    // This routine does not handle country codes at all
    private formatPhoneNumber(value) {
        if (!value) {
            return '';
        }

        // If the incoming value is a string, it could have embedded parentheses or dashes.
        // Remove any non-numeric characters.
        const valueStr = String(value).trim().replace(/\D/g, '');

        // Will return formattedNumber.
        // If valueStr isn't longer than an area code, just show number
        let formattedNumber = valueStr;

        // // If the first character is '1', strip it out and add it back
        // let c  = (valueStr[0] === '1') ? '1 ' : '';
        // valueStr = valueStr[0] === '1' ? valueStr.slice(1) : valueStr;

        // # (###) ###-#### as c (area) front-end
        const area = valueStr.substring(0, 3);
        const front = valueStr.substring(3, 6);
        const end = valueStr.substring(6, 10);

        if (front) {
            formattedNumber = '(' + area + ') ' + front;
        }

        if (end) {
            formattedNumber += ('-' + end);
        }
        return formattedNumber;
    }

    // Format phonenumber as: c (xxx) xxx-xxxx
    // or as close as possible if phonenumber length is not 10
    // If c is not '1' (country code not USA), does not use country code
    //      return function (number) {
    //         @param {Number | String} number - Number that will be formatted as telephone number
    // Returns formatted number:
    // If number.length === 10 : (###) ###-####
    // If number.length < 4    : ###
    // If number.length < 7    : (###) ###
    // This routine does not handle country codes that are not '1' (USA)
    private formatPhoneNumberWithCountryCode(value) {
        if (!value) {
            return '';
        }

        // If the incoming value is a string, it could have embedded parentheses or dashes.
        // Remove any non-numeric characters.
        let valueStr = String(value).trim().replace(/\D/g, '');

        // Will return formattedNumber.
        // If valueStr isn't longer than an area code, just show number
        let formattedNumber = valueStr;

        // If the first character is '1', strip it out and add it back
        const c = (valueStr[0] === '1') ? '1 ' : '';
        valueStr = valueStr[0] === '1' ? valueStr.slice(1) : valueStr;

        // # (###) ###-#### as c (area) front-end
        const area = valueStr.substring(0, 3);
        const front = valueStr.substring(3, 6);
        const end = valueStr.substring(6, 10);

        if (front) {
            formattedNumber = c + '(' + area + ') ' + front;
        }

        if (end) {
            formattedNumber += ('-' + end);
        }
        return formattedNumber;
    }
}
